import { IconButton } from "@/components/atoms/IconButton/IconButton";
import "./PinButton.scss";
import PinFilled from "./assets/PinFilled.module.svg";
import PinOutlined from "./assets/PinOutlined.module.svg";

export const PinButton: React.FC<{
  isPinned: boolean;
  onClick: () => void;
}> = ({ isPinned, onClick }) => {
  return (
    <IconButton
      className="pin-button"
      svgIcon={
        <div className="pin-icon-container">
          <div className="pin-filled">
            <PinFilled />
          </div>
          <div className="pin-outlined">
            <PinOutlined />
          </div>
        </div>
      }
      ariaLabel={isPinned ? "Unpin dashboard" : "Pin dashboard"}
      isActive={isPinned}
      onClick={onClick}
    />
  );
};
